import type { ProgressReport } from '@brighterly/lib-core-types/progress-report/interfaces'

import { useDisciplineStore } from '@stores/discipline'
import { useProgressReportStore } from '@stores/progress-report'

import { useCsRoutes } from '@composables/routes/cs-route.hook'

interface ProgressReportApiPayload {
  progressReportId: string | null
}

interface ProgressReportApiOptions {
  onStart?: () => void
  onSuccess?: (report: ProgressReport | null) => void
  onError?: (err: any) => void
  onFinish?: () => void
}

export const useProgressReportApi = async (payload: ProgressReportApiPayload, options?: ProgressReportApiOptions): Promise<void> => {
  const { $axios } = useNuxtApp()

  const disciplineStore = useDisciplineStore()
  const progressReportStore = useProgressReportStore()

  const disciplineId = disciplineStore.activeDiscipline?.id || null

  if (!disciplineId) {
    const message = 'Invalid discipline ID.'
    options?.onError?.({ message })
  } else {
    if (!payload.progressReportId) {
      const message = 'Invalid progress report ID.'
      options?.onError?.({ message })
    } else {
      const url = useCsRoutes('disciplines.progress-report', {
        '[discipline_id]': disciplineId,
        '[progress_report_id]': payload.progressReportId,
      })

      options?.onStart?.()
      progressReportStore.setReport(null)
      progressReportStore.setReportLoading(true)

      try {
        const { data } = await $axios.get(url!)
        const report: ProgressReport | null = data.data || null

        progressReportStore.setReport(report)
        options?.onSuccess?.(report)
      } catch (err: any) {
        console.error(err)
        options?.onError?.(err)
        progressReportStore.setReport(null)
      } finally {
        options?.onFinish?.()
        progressReportStore.setReportLoading(false)
      }
    }
  }
}
